// @ts-nocheck: converted from JS

import { DateRenderer } from '@/components/UI/DateRenderers/DateRenderers';
import '../CageCardTemplate.scss';
import { useMemo } from 'react';

const Animals = ({ animals, species }) => {
  const MAX_NUMBER_ANIMALS = 6;
  const cappedAnimals = useMemo(() => animals.slice(0, MAX_NUMBER_ANIMALS), [animals, MAX_NUMBER_ANIMALS]);
  const getStrainById = (id) => {
    let strain = null;
    for (const speciesItem of species) {
      const matchedStrain = speciesItem.strains?.find((strain) => strain.id === id);
      if (matchedStrain) {
        strain = matchedStrain;
        break;
      }
    }
    return strain;
  };
  return (
    <table className="w-100 tl" style={{ borderSpacing: 0, fontSize: 11, whiteSpace: 'nowrap' }}>
      <thead className="bg-black white">
        <tr className="card-row">
          <th>ID</th>
          <th>DOB</th>
          <th>Sex</th>
          <th>Strain</th>
        </tr>
      </thead>
      <tbody className="black">
        {cappedAnimals.map((animal) => (
          <tr className={`card-row max-${MAX_NUMBER_ANIMALS}`} key={animal.id}>
            <td>{animal.name}</td>
            <td>
              <DateRenderer value={animal.dob} defaultResponse="-" />
            </td>
            <td>{animal.sex}</td>
            <td>{animal.strain_id ? getStrainById(animal.strain_id)?.name || '-' : '-'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Animals;
